import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

import * as Composition from "./composition";

/**
 *
 * @description CurrentInputModel と DefaultInputModel を比較し、差分があれば ViewModel の各 Node が持つ、isEdited を true にし、ViewModel を返す
 *
 * @param viewModel
 * @param excludeKeys
 * @param currentInput
 * @param defaultInput
 *
 * @returns ViewModel
 */
export const isEditedMapper = <I, E, Q>(
	viewModel: AutoGeneratorForFormModel<I, E, Q>["ViewModel"],
	excludeKeys: Array<string>,
	currentInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	defaultInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
): AutoGeneratorForFormModel<I, E, Q>["ViewModel"] => {
	// 新規に編集されたデータを ViewModel にマッピングする
	viewModel = Composition.editedDataMapper(viewModel, excludeKeys, currentInput, defaultInput);
	// 新規に削除されたデータを ViewModel にマッピングする
	// viewModel = Composition.deletedDataMapper(viewModel, excludeKeys, currentInput, defaultInput);
	// 書き換えたデータを返す
	return viewModel;
};
